import gql from "graphql-tag";

export const CREATE_SUBSCRIPTION = gql`
  mutation AddSubscription($data: SubscriptionDataInput) {
    addSubscription(data: $data) {
      id
      insurancePlan {
        config
      }
    }
  }
`;

export const CREATE_SUBSCRIPTIONS = gql`
  mutation AddSubscriptions($data: [SubscriptionDataInput]) {
    addSubscriptions(data: $data) {
      id
      insurancePlan {
        id
        config
      }
    }
  }
`;

export const UPDATE_SUBSCRIPTION = gql`
  mutation UpdateSubscription(
    $data: SubscriptionDataInput
    $where: SubscriptionWhereInput
  ) {
    updateSubscription(data: $data, where: $where) {
      id
    }
  }
`;

export const DELETE_SUBSCRIPTION = gql`
  mutation DeleteSubscription($where: SubscriptionWhereInput) {
    deleteSubscription(where: $where) {
      id
    }
  }
`;

export const SEND_SUBSCRIPTION_ATTACHMENTS = gql`
  mutation sendSubscriptionAttachments(
    $where: SubscriptionWhereInput
    $data: SubscriptionAttachmentsInput
  ) {
    sendSubscriptionAttachments(where: $where, data: $data) {
      id
    }
  }
`;

export const EXPORT_SUBSCRIPTIONS = gql`
  mutation exportSubscriptions(
    $where: SubscriptionWhereInput
    $gt: SubscriptionWhereInput
    $lt: SubscriptionWhereInput
  ) {
    exportSubscriptions(where: $where, gt: $gt, lt: $lt)
  }
`;

export const DEPOSIT_AMELLIS_CIBLEMUT_SFTP = gql`
  mutation depositAmellisCiblemutSftp(
    $where: SubscriptionWhereInput
    $from: DateTime
    $to: DateTime
  ) {
    depositAmellisCiblemutSftp(where: $where, from: $from, to: $to)
  }
`;

export const SEND_SUBSCRIPTIONS_BY_EMAIL = gql`
  mutation sendSubscriptionsByEmail(
    $where: SubscriptionWhereInput
    $gt: SubscriptionWhereInput
    $lt: SubscriptionWhereInput
  ) {
    sendSubscriptionsByEmail(where: $where, gt: $gt, lt: $lt)
  }
`;

export const SEND_SUBSCRIPTION_ADDITIONAL_DOCUMENTS = gql`
  mutation sendSubscriptionAdditionalDocument(
    $where: SubscriptionWhereInput
    $data: [AttachmentDataInput]
  ) {
    sendSubscriptionAdditionalDocument(where: $where, data: $data) {
      id
    }
  }
`;

export const SEND_SUBSCRIPTION_LINK = gql`
  mutation SendSubscriptionLink($data: SubscriptionLinkInput) {
    sendSubscriptionLink(data: $data)
  }
`;

export const SEND_SUBSCRIPTION_DOCUMENTS = gql`
  mutation SendSubscriptionDocuments($where: SubscriptionWhereInput) {
    sendSubscriptionDocuments(where: $where) {
      id
    }
  }
`;

export const SEND_ADDITIONAL_DOCUMENTS = gql`
  mutation SendSubscriptionAdditionalDocuments($where: SubscriptionWhereInput) {
    sendSubscriptionAdditionalDocuments(where: $where) {
      id
    }
  }
`;

export const ADD_EXTERNAL_SUBSCRIPTION = gql`
  mutation AddExternalSubscription($where: SubscriptionWhereInput) {
    addExternalSubscription(where: $where) {
      id
    }
  }
`;

export const SEND_TO_MANAGEMENT = gql`
  mutation SendToManagement($where: SubscriptionWhereInput) {
    sendToManagement(where: $where) {
      id
      externalManagement
    }
  }
`;

export const SEND_TO_MANAGEMENT_MANUALLY = gql`
  mutation SendToManagementManually(
    $where: SubscriptionWhereInput
    $subject: String!
    $html: String!
  ) {
    sendToManagementManually(where: $where, subject: $subject, html: $html) {
      id
      externalManagement
    }
  }
`;

const subscriptions = {
  CREATE_SUBSCRIPTION,
  CREATE_SUBSCRIPTIONS,
  UPDATE_SUBSCRIPTION,
  DELETE_SUBSCRIPTION,
  SEND_SUBSCRIPTION_LINK,
  SEND_SUBSCRIPTION_DOCUMENTS,
  SEND_ADDITIONAL_DOCUMENTS,
  EXPORT_SUBSCRIPTIONS,
  DEPOSIT_AMELLIS_CIBLEMUT_SFTP,
  SEND_SUBSCRIPTIONS_BY_EMAIL,
  SEND_TO_MANAGEMENT,
};

export default subscriptions;
